import React from 'react';

// Carpetta brand mark: a flame fused with a piston/gear motif.
export default function Logo({ className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="relative grid h-11 w-11 place-items-center rounded-xl bg-gradient-to-br from-ember-500 to-ember-700 shadow-ember animate-flame-flicker">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          className="h-6 w-6 text-ink-900"
          aria-hidden="true"
        >
          <path
            d="M12 2c1.5 3 4 4.5 4 8a4 4 0 1 1-8 0c0-1.2.4-2 1-2.8C8.5 9 8 10.5 8 12c-1-1-1.5-2.5-1.5-4C6.5 5 9 3.5 12 2Z"
            fill="currentColor"
          />
          <circle cx="12" cy="13.5" r="1.6" fill="#7c2d12" />
        </svg>
      </span>
      <div className="leading-none">
        <span className="font-display text-xl font-extrabold tracking-tight text-white">
          CAR<span className="text-gradient-fire">PETTA</span>
        </span>
        <span className="mt-0.5 block text-[0.6rem] font-medium uppercase tracking-[0.3em] text-white/40">
          OEM Auto Parts
        </span>
      </div>
    </div>
  );
}
